import Form from '@admin/components/form'
import PropTypes from 'prop-types'
import React from 'react'

class SecurityQuestion extends React.Component {

  static contextTypes = {
    flash: PropTypes.object,
    modal: PropTypes.object
  }

  _handleCancel = this._handleCancel.bind(this)
  _handleSuccess = this._handleSuccess.bind(this)

  render() {
    return <Form { ...this._getForm() } />
  }

  _getForm() {
    return {
      title: 't(Change Security Question)',
      method: 'PATCH',
      endpoint: '/api/admin/account',
      action: '/api/admin/account/security/question',
      cancelSvg: 'chevron_left',
      onCancel: this._handleCancel,
      onSuccess: this._handleSuccess,
      sections: [
        {
          fields: [
            { label: 't(Question)', name: 'security_question_id', type: 'lookup', endpoint: '/api/admin/security_questions', valueKey: 'id', textKey: 'text', required: true },
            { label: 't(Answer)', name: 'security_question_answer', type: 'textfield', required: true }
          ]
        }
      ]
    }
  }

  _handleCancel() {
    this.context.modal.pop()
  }

  _handleSuccess(user) {
    this.context.modal.pop()
  }

}

export default SecurityQuestion
